import { render, staticRenderFns } from "./batch_download.vue?vue&type=template&id=67146f44&scoped=true"
import script from "./batch_download.vue?vue&type=script&lang=js"
export * from "./batch_download.vue?vue&type=script&lang=js"
import style0 from "./batch_download.vue?vue&type=style&index=0&id=67146f44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67146f44",
  null
  
)

export default component.exports